import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BrandingContext = createContext({
  siteName: 'CCA Montreal',
  logoUrl: '',
  faviconUrl: '',
  facebookUrl: '',
  instagramUrl: '',
  tiktokUrl: '',
  youtubeUrl: '',
  loaded: false,
});

export const useBranding = () => useContext(BrandingContext);

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({
    siteName: 'CCA Montreal',
    logoUrl: '',
    faviconUrl: '',
    facebookUrl: '',
    instagramUrl: '',
    tiktokUrl: '',
    youtubeUrl: '',
    loaded: false,
  });

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/settings/branding`);
        const data = response.data;
        const newBranding = {
          siteName: data.site_name || 'CCA Montreal',
          logoUrl: data.logo_url || '',
          faviconUrl: data.favicon_url || '',
          facebookUrl: data.facebook_url || '',
          instagramUrl: data.instagram_url || '',
          tiktokUrl: data.tiktok_url || '',
          youtubeUrl: data.youtube_url || '',
          loaded: true,
        };
        setBranding(newBranding);

        // Set default document title (react-helmet pages will override this)
        if (data.site_name) {
          window.__CCA_DEFAULT_TITLE = data.site_name;
          document.title = data.site_name;
        }

        // Dynamically set favicon
        if (data.favicon_url) {
          let faviconLink = document.querySelector("link[rel~='icon']");
          if (!faviconLink) {
            faviconLink = document.createElement('link');
            faviconLink.rel = 'icon';
            document.head.appendChild(faviconLink);
          }
          faviconLink.href = data.favicon_url;
        }
      } catch (error) {
        setBranding(prev => ({ ...prev, loaded: true }));
      }
    };
    fetchBranding();
  }, []);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
};
